import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CartDialogComponent } from "src/app/components/pages/cart-dialog/cart-dialog.component";
import { CartService } from "src/app/components/shared/services/cart.service";
import { ProductService } from "src/app/components/shared/services/product.service";
import { WishlistService } from "src/app/components/shared/services/wishlist.service";
import { Product } from "src/app/modals/product.model";
import { ItemsService } from "src/app/services/items.service";
import { ProductDialogComponent } from "../../products/product-dialog/product-dialog.component";

@Component({
  selector: "app-vista-previa-list",
  templateUrl: "./vista-previa-list.component.html",
  styleUrls: ["./vista-previa-list.component.sass"],
})
export class VistaPreviaListComponent implements OnInit {
  allItems: any[] = [];
  constructor(
    private cartService: CartService,
    public productsService: ProductService,
    private wishlistService: WishlistService,
    private dialog: MatDialog,
    private router: Router,
    private itemService: ItemsService,
    private spinner: NgxSpinnerService
  ) {}
  public viewType: string = "grid";
  public viewCol: number = 25;
  productos: any[] = [
    {
      idItemEC: 1427,
      TItemEC: "ITM",
      TItemECNom: "Items - General",
      idItem: 16752,
      Marca: "ADVANCE",
      Codigo: "AAC02",
      Nro: 42,
      NombreItm: "DISCO DURO DE PRUEBA",
      UniMed: "UND",
      UniMedDeno: "UNIDAD",
      CodigoBarras: "456325",
      PV1: 50,
      PV2: 50,
      PV3: 50,
      PV4: 0,
      PV5: 0,
      PV6: 0,
      PorcDscto: "",
      APedido: true,
      TED: 4,
      TipoIGV: "",
      Mostrar: true,
      SaldoG: 0,
      OrdenIEC: 0,
      ClicCant: 0,
      ValCant: 0,
      ValSum: 0,
      ValProm: 0,
      Otros: "<PRE></PRE>",
      ImagenP:
        "https://devscon.pe/demo/nova/datastorage/items/07771c3e-26f7-42cb-bebd-2b712539e4c1.jpg",
      Habilitado: true,
      Filial: "NP",
      Usuario: "VIASYSTEM",
      FechaHoraReg: "2022-12-27T12:10:09.893",
      UsuarioMod: "VIASYSTEM",
      FechaHoraMod: "2022-12-27T13:31:48.74",
      imagenProducto: "",
    },
  ];
  ngOnInit(): void {
    // localStorage.setItem("vistaPrevia",JSON.stringify(this.productos))
    this.cargarItemVista();
  }
  cargarItemVista() {
    let item: any = JSON.parse(localStorage.getItem("vistaPrevia"));

    if (item != null) {
      this.allItems = item;
    } else {
      // console.log(item)
      this.router.navigate([""]);
    }
  }
  public changeViewType(viewType, viewCol) {
    this.viewType = viewType;
    this.viewCol = viewCol;
  }

  inicializar() {
    window.scrollTo(0, 0);
    // ////console.log(this._product);
    // if (this._product.ValProm == null) {
    //   this.valProm = 0;
    // } else {
    //   this.valProm = this._product.ValProm;
    // }
  }

  // Add to cart
  public addToCart(product: Product, quantity: number = 1) {
    // console.log(product)
    if (product.PV6 > 0) {
      if (quantity == 0 || product.SaldoG == 0) return false;
      if (sessionStorage.getItem("tp") == null) {
        sessionStorage.setItem("tp", "TA");
        product.PVVenta = product.PV6;
      } else {
        if (sessionStorage.getItem("tp") == "TA") {
          product.PVVenta = product.PV6;
        } else {
          product.PVVenta = product.PV6;
        }
      }
    } else {
      if (quantity == 0 || product.SaldoG == 0) return false;

      if (sessionStorage.getItem("tp") == null) {
        sessionStorage.setItem("tp", "TA");
        product.PVVenta = product.PV2;
      } else {
        if (sessionStorage.getItem("tp") == "TA") {
          product.PVVenta = product.PV2;
        } else {
          product.PVVenta = product.PV3;
        }
      }
    }
    // ////console.log(_product);
    if (product.PV2 > 0) {
      this.cartService.addToCart(product, quantity);
      this.dialog.open(CartDialogComponent, {
        data: null,
        panelClass: "product-dialog",
        width: "800px",
      });
    }
  }

  // Add to wishlist
  public addToWishlist(product: Product) {
    this.wishlistService.addToWishlist(product);
  }

  // Add to compare
  public addToCompare(product: Product) {
    this.productsService.addToCompare(product);
  }

  public openProductDialog(product) {
    let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: "product-dialog",
      width: "850px",
    });
  }
  async verProducto(product: any) {
    this.spinner.show();
    localStorage.setItem("productDetail", JSON.stringify(product));
    this.router.navigate(["/home/vistaPreviaDet"]);
  }
  enviarMensajeWsp() {}
}
